

export function convertToCsv(
    data: any[][],
    options?: {
        delimiter?: string,
        commaDecimals?: boolean,
    }
): string {
    const delimiter = options?.delimiter ?? ',';
    return data.map(row =>
        row.map(value => escapeCsvValue(value, delimiter)).join(delimiter)
    ).join('\n');
}

function escapeCsvValue(value: any, delimiter: string): string {
    const text = value == null ? '' : value.toString();
    if (![delimiter, '"', '\r', '\n'].some(character => text.includes(character))) {
        return text;
    }
    return `"${text.replaceAll('"', '""')}"`;
}
